module.exports = __webpack_public_path__ + "img/firefox-1.4cc217ae.webp";